import noWheel from "./modules/noWheel";
window.addEventListener('DOMContentLoaded', () => {
    noWheel();
});